export const merchantDelegationState = {
  merchantDelegationFormStatus: false,
  merchantDelegationIsEdit: false,
  merchantDelegationSelectedForEdit: null,
};